import { Trans } from '@common/i18n/trans';
import { useFormContext } from 'react-hook-form';
import { FormSelect } from '@common/ui/forms/select/select';
import { Item } from '@common/ui/forms/listbox/item';
import { Button } from '@common/ui/buttons/button';
import { AddIcon } from '@common/icons/material/Add';
import { useTrans } from '@common/i18n/use-trans';
import { UploadIcon } from '@common/icons/material/Upload';
import { DeleteIcon } from '@common/icons/material/Delete';
import { useEffect, useState } from 'react';
import { useRemoveItemRateSheet } from '@app_modules/requests/use-remove-item-rate-sheet';
import { useRemoveAnalyzeItemRateSheet } from '@app_modules/requests/use-remove-analyze-item-rate-sheet';
import { FormTextField } from '@common/ui/forms/input-field/text-field/text-field';

export function ParentRowSheet({ id, pidx, index, item, subItem, subItems, onAddSubItems, cnt, setCnt, removeParent, last, changeLoanProgramType, changeDescription, changeAnalysisPrompt, loan_program_types }: any) {
  const { trans } = useTrans();

  const { watch } = useFormContext<any>();
  const loan_program_type = watch(`${pidx}_${index}_loan_program_type`);

  useEffect(() => {
    if (loan_program_type) {
      changeLoanProgramType(loan_program_type);
    }
  }, [loan_program_type]);

  const removeAnalyzeItemRateSheet = useRemoveAnalyzeItemRateSheet(id, loan_program_type);

  const [loanProgramTypes, setLoanProgramTypes] = useState([]);

  useEffect(() => {
    if (loan_program_types) {
      setLoanProgramTypes(loan_program_types);
    }
  }, [id, loan_program_types]);

  // Check if the loan_program_type already exists in another sub-item
  const isDuplicateLoanProgramType = (newLoanProgramType: string, currentIndex: number) => {
    return subItems.some((item: any, idx: number) => {
      if (idx === currentIndex) return false; // Skip the current sub-item
      return item.loan_program_type === newLoanProgramType;
    });
  };

  return (
    <>
      <tr key={`parent-row-${pidx}-${index}`} className="border-b transition duration-300 ease-in-out hover:bg-gray-100 w-[100%]">
        <td className={`text-sm text-gray-900 px-6 py-4 whitespace-nowrap`}>
          <FormSelect
            name={`${pidx}_${index}_loan_program_type`}
            selectionMode="single"
            required
            placeholder={trans({ message: 'Select loan product' })}
            className='w-150'
            onSelectionChange={val => {
              const newLoanProgramType = val.toString();
              // Check for duplicates before updating
              if (isDuplicateLoanProgramType(newLoanProgramType, index)) {
                console.warn(`Loan Program Type "${newLoanProgramType}" already exists for this parent. Please select a unique value.`);
                return;
              }
              subItems[index]['loan_program_type'] = newLoanProgramType;
              onAddSubItems(pidx, subItems);
              changeLoanProgramType(newLoanProgramType);
            }}
          >
            {loanProgramTypes?.map((loan_program_type: string) => (
              <Item value={loan_program_type} key={loan_program_type}>
                <Trans message={loan_program_type} />
              </Item>
            ))}
          </FormSelect>
        </td>
        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
          <Button
            className='mr-10'
            startIcon={<AddIcon />}
            size={'xs'} variant="outline" color="orange"
            onClick={() => {
              subItems.push({ key: last.toString(), loan_program_type: "", investor_code: "", prompt: "" });
              setCnt(cnt + 1);
              onAddSubItems(pidx, subItems);
            }}
          >
            <Trans message="Add Lender Product" />
          </Button>

          <Button
            size={'xs'} variant="outline" color="red"
            onClick={() => {
              removeParent(true, pidx);
              if (id && loan_program_type) {
                removeAnalyzeItemRateSheet.mutate(
                  { id: id, loan_program_type: loan_program_type },
                  {
                    onSuccess: (response) => {
                      //onProcess(response.status, response.total_files, response.uploaded_date, response.file_name);
                    },
                  },
                );
              }
            }}
            disabled={removeAnalyzeItemRateSheet.isPending}
          >
            <DeleteIcon />
          </Button>
        </td>
        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
          <FormTextField
            className="w-[100%]"
            name={`${pidx}_${index}_description`}
            inputElementType="textarea"
            rows={1}
            cols={80}
            onChange={e => {
              const newDescription = e.target.value;
              subItems[index]['description'] = newDescription;
              onAddSubItems(pidx, subItems);
              changeDescription(newDescription);
            }}
          />
        </td>
        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap" colSpan={4}>
          <FormTextField
            className="w-[100%]"
            name={`${pidx}_${index}_analysis_prompt`}
            inputElementType="textarea"
            rows={1}
            cols={80}
            onChange={e => {
              const newAnalysisPrompt = e.target.value;
              subItems[index]['analysis_prompt'] = newAnalysisPrompt;
              onAddSubItems(pidx, subItems);
              changeAnalysisPrompt(newAnalysisPrompt);
            }}
          />
        </td>
      </tr>

      <tr className='bg-gray-300'>
        <th scope="col" className="w-[10%] bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left">
          <Trans message="Lender Name" />
        </th>
        <th scope="col" className="w-[10%] bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left">
          <Trans message="Sheet Name" />
        </th>
        <th scope="col" className="w-[15%] bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left"></th>
        <th scope="col" className="w-[15%] bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left"></th>
        <th scope="col" className="w-[15%] bg-gray-300 text-md font-medium text-gray-900 px-6 py-4 text-left"></th>
        <th scope="col" className="w-[5%] bg-sgray-300 text-md font-medium text-gray-900 px-6 py-4 text-left"></th>
        <th scope="col" className="w-[5%] bg-sgray-300 text-md font-medium text-gray-900 px-6 py-4 text-left"></th>
      </tr>
    </>
  );
}